export default __webpack_public_path__ + "static/calendar-9adb7e497dfa612362246b809cd39902.png";